function openCollapsibleTabsFromHash() {
  const raw = window.location.hash.slice(1);
  if (!raw) return;

  let id;
  try {
    id = decodeURIComponent(raw);
  } catch {
    return;
  }

  const target = document.getElementById(id);
  if (!target) return;

  const item = target.classList.contains('accordion-item') ? target : target.closest('.accordion-item');
  if (!item) return;

  const details = item.querySelector('details[is="accordion-group"]');
  if (details && !details.open) {
    details.open = true;
  }

  window.requestAnimationFrame(() => {
    setTimeout(() => {
      item.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  });
}

if (!window.__collapsibleTabsHashListeners) {
  window.__collapsibleTabsHashListeners = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCollapsibleTabsFromHash);
  } else {
    openCollapsibleTabsFromHash();
  }
  window.addEventListener('hashchange', openCollapsibleTabsFromHash);
}

if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
